export const genres = [
  "动作",
  "爱情",
  "喜剧",
  "科幻",
  "悬疑",
  "剧情",
  "犯罪",
  "古装",
  "都市",
  "青春",
  "灾难",
  "惊悚",
  "历史",
  "战争",
  "恐怖",
  "医疗",
  "武侠",
  "家庭",
  "冒险",
  "励志",
];

export const regions = ["中国", "中国香港", "美国", "韩国", "日本"];

export const years = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019];